import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { SPECS } from '../specs';

export const getPanoramaClient = (flowAPI: PlatformControllerFlowAPI) => {
  const isPanoramaEnabled = flowAPI.experiments.enabled(
    SPECS.EnablePanoramaIntegration
  );
  return isPanoramaEnabled ? flowAPI.panoramaClient : null;
};
